import { Label } from "../../common/GeneralClasses";
import { LabelsMapper } from "./LabelsMapper";
import { UnsubsribeFormLabels } from "../../labels/UnsubsribeFormLabels";

export class UnsubscribeFormLabelsMapper extends LabelsMapper<UnsubsribeFormLabels> {
  get(labels: Label[]): UnsubsribeFormLabels {
    let resultMap = new Map();

    Object.entries(new UnsubsribeFormLabels()).forEach((entry) => {
      resultMap.set(entry[0], this.getLabel(labels, entry[1].name));
    });
    return Object.fromEntries(resultMap);
  }

  
}
